import React from 'react';
import { Box, Typography } from '@mui/material';

const FILLED_COLOR = '#6B1D2F'; // bordowy — spójny z WORK_COLOR z wykresu praca/przestój
const TRACK_COLOR = '#EAD9C9';  // jasny beż — spójny z IDLE_COLOR z wykresu
const WORKING_COLOR = '#2e7d32'; // zielony — spójny z oznaczeniem aktywności gdzie indziej w apce
const IDLE_COLOR = '#9e9e9e';
const DOT_COUNT = 20;
const DOT_STEP = 0.5;
const DOT_MAX = DOT_COUNT * DOT_STEP;

function ReportPaceIndicator({
  averagePerHour,
  unit = 'm3/h',
  total = 0,
  totalUnit = 'm3',
  isWorking = false,
  label = 'CIĘCIE',
  title = 'Średnio na godzinę',
}) {
  const filledDots = averagePerHour == null
    ? 0
    : Math.min(DOT_COUNT, Math.max(0, Math.round(averagePerHour / DOT_STEP)));

  return (
    <Box sx={{ minWidth: 220 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>{title}</Typography>
        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: 'text.secondary', letterSpacing: 0.5 }}>
          {label}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 0.5 }}>
        <Typography sx={{ fontSize: '30px', fontWeight: 600 }}>
          {averagePerHour !== null && averagePerHour !== undefined ? averagePerHour.toFixed(2) : '—'}
        </Typography>
        <Typography sx={{ fontSize: '14px', color: 'text.secondary' }}>{unit}</Typography>
      </Box>

      {/* Pasek kropek: 20 kropek po 0.5 = skala 0–10 */}
      <Box sx={{ display: 'flex', gap: 0.5, mt: 1.5 }}>
        {Array.from({ length: DOT_COUNT }).map((_, i) => (
          <Box key={i} sx={{
            flex: 1,
            height: 6,
            borderRadius: 1,
            bgcolor: i < filledDots ? FILLED_COLOR : TRACK_COLOR,
          }} />
        ))}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.25 }}>
        <Typography sx={{ fontSize: '11px', color: 'text.secondary' }}>0</Typography>
        <Typography sx={{ fontSize: '11px', color: 'text.secondary' }}>{DOT_MAX}</Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 1.5 }}>
        <Box sx={{
          width: 8, height: 8, borderRadius: '50%',
          bgcolor: isWorking ? WORKING_COLOR : IDLE_COLOR,
        }} />
        <Typography sx={{ fontSize: '13px', color: 'text.secondary' }}>
          {isWorking ? 'Praca' : 'Postój'}
        </Typography>
      </Box>
    </Box>
  );
}

export default ReportPaceIndicator;
